import { motorPrivateService } from './motorPrivateService';
import { saveState, loadState } from '../../../../libs/persist';

const persistedState = loadState('motorPrivateState') || {};

const motorPrivateModule = {
	namespaced: true,
	state: () => ({
		selectedCoverType: persistedState.selectedCoverType || null,
		vehicleValue: persistedState.vehicleValue || null,
		quotedProducts: persistedState.quotedProducts || [],
		selectedProduct: persistedState.selectedProduct || null,
		selectedOptionalBenefits: persistedState.selectedOptionalBenefits || [],
		coreBenefitLimits: persistedState.coreBenefitLimits || {},
		editingCoreBenefits: persistedState.editingCoreBenefits || {},
		editingOptionalBenefits: persistedState.editingOptionalBenefits || {},
		selectedComparisonProducts:
			persistedState.selectedComparisonProducts || [],
		vehicleDetails: persistedState.vehicleDetails || {
			make: '',
			model: '',
			registrationNumber: '',
			chassisNumber: '',
			engineNumber: '',
			engineCapacity: null,
			bodyType: '',
			fuelType: '',
			modifications: null,
			modificationDetails: '',
			modificationDate: '',
			usePurpose: '',
			colour: '',
			yearOfManufacture: null,
			antiTheftDevice: '',
		},
		kycDetails: persistedState.kycDetails || {
			fullName: '',
			idNumber: '',
			kraPin: '',
			phoneNumber: '',
			email: '',
			address: '',
		},
		coverDetails: persistedState.coverDetails || {
			coverPeriod: '12',
			startDate: '',
		},
		paymentStatus: persistedState.paymentStatus || 'pending',
		errors: persistedState.errors || {},
		loading: persistedState.loading || false,
		validationAttempted: persistedState.validationAttempted || false,
	}),
	mutations: {
		SET_SELECTED_COVER_TYPE(state, type) {
			state.selectedCoverType = type;
			saveState('motorPrivateState', state);
		},
		SET_VEHICLE_VALUE(state, value) {
			state.vehicleValue = value;
			saveState('motorPrivateState', state);
		},
		SET_QUOTED_PRODUCTS(state, products) {
			state.quotedProducts = JSON.parse(JSON.stringify(products));
			saveState('motorPrivateState', state);
		},
		SET_SELECTED_PRODUCT(state, product) {
			state.selectedProduct = JSON.parse(JSON.stringify(product));
			state.selectedOptionalBenefits =
				product && product.selectedBenefits
					? JSON.parse(JSON.stringify(product.selectedBenefits))
					: [];
			state.coreBenefitLimits =
				product && product.coreBenefits
					? product.coreBenefits.reduce(
							(acc, benefit) => ({
								...acc,
								[benefit.id]: benefit.selectedLimit || 0,
							}),
							{},
						)
					: {};
			state.editingCoreBenefits = {};
			state.editingOptionalBenefits = {};
			saveState('motorPrivateState', state);
		},
		SET_SELECTED_OPTIONAL_BENEFITS(state, benefits) {
			state.selectedOptionalBenefits = JSON.parse(
				JSON.stringify(benefits),
			);
			saveState('motorPrivateState', state);
		},
		SET_CORE_BENEFIT_LIMITS(state, { benefitId, limit }) {
			state.coreBenefitLimits = {
				...state.coreBenefitLimits,
				[benefitId]: limit,
			};
			saveState('motorPrivateState', state);
		},
		SET_EDITING_CORE_BENEFIT(state, { benefitId, isEditing }) {
			state.editingCoreBenefits = {
				...state.editingCoreBenefits,
				[benefitId]: isEditing,
			};
			saveState('motorPrivateState', state);
		},
		SET_EDITING_OPTIONAL_BENEFIT(state, { benefitId, isEditing }) {
			state.editingOptionalBenefits = {
				...state.editingOptionalBenefits,
				[benefitId]: isEditing,
			};
			saveState('motorPrivateState', state);
		},
		ADD_COMPARISON_PRODUCT(state, product) {
			if (
				!state.selectedComparisonProducts.find(
					(p) => p.id === product.id,
				)
			) {
				state.selectedComparisonProducts = [
					...state.selectedComparisonProducts,
					JSON.parse(JSON.stringify(product)),
				];
			}
			saveState('motorPrivateState', state);
		},
		REMOVE_COMPARISON_PRODUCT(state, productId) {
			state.selectedComparisonProducts =
				state.selectedComparisonProducts.filter(
					(p) => p.id !== productId,
				);
			saveState('motorPrivateState', state);
		},
		CLEAR_COMPARISON_PRODUCTS(state) {
			state.selectedComparisonProducts = [];
			saveState('motorPrivateState', state);
		},
		UPDATE_VEHICLE_DETAILS(state, details) {
			state.vehicleDetails = { ...state.vehicleDetails, ...details };
			saveState('motorPrivateState', state);
		},
		UPDATE_KYC_DETAILS(state, details) {
			state.kycDetails = { ...state.kycDetails, ...details };
			saveState('motorPrivateState', state);
		},
		UPDATE_COVER_DETAILS(state, details) {
			state.coverDetails = { ...state.coverDetails, ...details };
			saveState('motorPrivateState', state);
		},
		SET_PAYMENT_STATUS(state, status) {
			state.paymentStatus = status;
			saveState('motorPrivateState', state);
		},
		SET_ERRORS(state, errors) {
			state.errors = { ...errors };
			saveState('motorPrivateState', state);
		},
		CLEAR_ERRORS(state) {
			state.errors = {};
			saveState('motorPrivateState', state);
		},
		SET_LOADING(state, loading) {
			state.loading = loading;
			saveState('motorPrivateState', state);
		},
		RESET_FLOW(state) {
			state.selectedCoverType = null;
			state.vehicleValue = null;
			state.quotedProducts = [];
			state.selectedProduct = null;
			state.selectedOptionalBenefits = [];
			state.coreBenefitLimits = {};
			state.editingCoreBenefits = {};
			state.editingOptionalBenefits = {};
			state.selectedComparisonProducts = [];
			state.vehicleDetails = {
				make: '',
				model: '',
				registrationNumber: '',
				chassisNumber: '',
				engineNumber: '',
				engineCapacity: null,
				bodyType: '',
				fuelType: '',
				modifications: null,
				modificationDetails: '',
				modificationDate: '',
				usePurpose: '',
				colour: '',
				yearOfManufacture: null,
				antiTheftDevice: '',
			};
			state.kycDetails = {
				fullName: '',
				idNumber: '',
				kraPin: '',
				phoneNumber: '',
				email: '',
				address: '',
			};
			state.coverDetails = {
				coverPeriod: '12',
				startDate: '',
			};
			state.paymentStatus = 'pending';
			state.errors = {};
			state.loading = false;
			state.validationAttempted = false;
			saveState('motorPrivateState', state);
		},
	},
	actions: {
		setSelectedProduct({ commit }, product) {
			commit('SET_SELECTED_PRODUCT', product);
		},
		setSelectedCoverType({ commit }, type) {
			commit('SET_SELECTED_COVER_TYPE', type);
		},
		setVehicleValue({ commit }, value) {
			commit('SET_VEHICLE_VALUE', value);
		},
		setQuotedProducts({ commit }, products) {
			commit('SET_QUOTED_PRODUCTS', products);
		},
		setSelectedOptionalBenefits({ commit }, benefits) {
			commit('SET_SELECTED_OPTIONAL_BENEFITS', benefits);
		},
		setCoreBenefitLimits({ commit }, payload) {
			commit('SET_CORE_BENEFIT_LIMITS', payload);
		},
		setEditingCoreBenefit({ commit }, payload) {
			commit('SET_EDITING_CORE_BENEFIT', payload);
		},
		setEditingOptionalBenefit({ commit }, payload) {
			commit('SET_EDITING_OPTIONAL_BENEFIT', payload);
		},
		addComparisonProduct({ commit }, product) {
			commit('ADD_COMPARISON_PRODUCT', product);
		},
		removeComparisonProduct({ commit }, productId) {
			commit('REMOVE_COMPARISON_PRODUCT', productId);
		},
		clearComparisonProducts({ commit }) {
			commit('CLEAR_COMPARISON_PRODUCTS');
		},
		updateVehicleDetails({ commit }, details) {
			commit('UPDATE_VEHICLE_DETAILS', details);
		},
		updateKycDetails({ commit }, details) {
			commit('UPDATE_KYC_DETAILS', details);
		},
		updateCoverDetails({ commit }, details) {
			commit('UPDATE_COVER_DETAILS', details);
		},
		setPaymentStatus({ commit }, status) {
			commit('SET_PAYMENT_STATUS', status);
		},
		setErrors({ commit }, errors) {
			commit('SET_ERRORS', errors);
		},
		clearErrors({ commit }) {
			commit('CLEAR_ERRORS');
		},
		setLoading({ commit }, loading) {
			commit('SET_LOADING', loading);
		},
		resetFlow({ commit }) {
			commit('RESET_FLOW');
		},
		async fetchQuotations({ commit }) {
			commit('SET_LOADING', true);
			try {
				const quotations = await motorPrivateService.fetchQuotations();
				commit('SET_QUOTED_PRODUCTS', quotations);
			} catch (error) {
				commit('SET_ERRORS', {
					fetchQuotations: 'Failed to fetch quotations.',
				});
			} finally {
				commit('SET_LOADING', false);
			}
		},
	},
	getters: {
		validationErrors: (state) => (routeName) => {
			const errors = {};
			switch (routeName) {
				case 'CoverTypeSelection':
					if (!state.selectedCoverType) {
						errors.selectedCoverType =
							'Please select a cover type.';
					}
					break;
				case 'ProductQuotation':
					if (state.quotedProducts.length === 0) {
						errors.quotedProducts =
							'No products available. Please try again.';
					}
					break;
				case 'ViewProductDetails':
					if (!state.selectedProduct) {
						errors.selectedProduct = 'Please select a product.';
					}
					break;
				case 'VehicleValuation':
					if (!state.selectedCoverType) {
						errors.selectedCoverType =
							'Please select a cover type.';
					}
					if (
						state.selectedCoverType === 'comprehensive' &&
						(!state.vehicleValue || state.vehicleValue <= 0)
					) {
						errors.vehicleValue =
							'Vehicle value must be greater than 0.';
					}
					break;
				case 'BasicCoverDetails':
					if (!state.coverDetails.coverPeriod) {
						errors.coverPeriod = 'Cover period is required.';
					}
					if (!state.coverDetails.startDate) {
						errors.startDate = 'Start date is required.';
					}
					break;
				case 'BenefitsPage':
				case 'Quotation':
					if (!state.selectedCoverType) {
						errors.selectedCoverType =
							'Please select a cover type.';
					}
					if (!state.selectedProduct) {
						errors.selectedProduct = 'Please select a product.';
					}
					break;
				case 'CompareProducts':
					if (state.selectedComparisonProducts.length === 0) {
						errors.comparisonProducts =
							'No products selected for comparison.';
					}
					break;
				case 'VehicleDetailsForm':
					if (!state.vehicleDetails.make) {
						errors.make = 'Vehicle make is required.';
					}
					if (!state.vehicleDetails.model) {
						errors.model = 'Vehicle model is required.';
					}
					if (!state.vehicleDetails.registrationNumber) {
						errors.registrationNumber =
							'Registration number is required.';
					}
					if (!state.vehicleDetails.chassisNumber) {
						errors.chassisNumber = 'Chassis number is required.';
					}
					if (!state.vehicleDetails.engineNumber) {
						errors.engineNumber = 'Engine number is required.';
					}
					if (!state.vehicleDetails.engineCapacity) {
						errors.engineCapacity = 'Engine capacity is required.';
					}
					if (!state.vehicleDetails.fuelType) {
						errors.fuelType = 'Fuel type is required.';
					}
					if (!state.vehicleDetails.bodyType) {
						errors.bodyType = 'Body type is required.';
					}
					if (!state.vehicleDetails.usePurpose) {
						errors.usePurpose = 'Use purpose is required.';
					}
					if (!state.vehicleDetails.colour) {
						errors.colour = 'Colour is required.';
					}
					if (!state.vehicleDetails.yearOfManufacture) {
						errors.yearOfManufacture =
							'Year of manufacture is required.';
					}
					if (!state.vehicleDetails.antiTheftDevice) {
						errors.antiTheftDevice =
							'Anti-theft device information is required.';
					}
					if (state.vehicleDetails.modifications === null) {
						errors.modifications =
							'Please specify if the vehicle has modifications.';
					} else if (state.vehicleDetails.modifications === 'yes') {
						if (!state.vehicleDetails.modificationDetails) {
							errors.modificationDetails =
								'Modification details are required.';
						}
						if (!state.vehicleDetails.modificationDate) {
							errors.modificationDate =
								'Modification date is required.';
						}
					}
					break;
				case 'KYCDetailsForm':
					if (!state.kycDetails.fullName) {
						errors.fullName = 'Full name is required.';
					}
					if (!state.kycDetails.idNumber) {
						errors.idNumber = 'ID number is required.';
					}
					if (!state.kycDetails.email) {
						errors.email = 'Email address is required.';
					}
					if (!state.kycDetails.phoneNumber) {
						errors.phoneNumber = 'Phone number is required.';
					}
					if (!state.kycDetails.kraPin) {
						errors.kraPin = 'KRA PIN is required.';
					}
					if (!state.kycDetails.address) {
						errors.address = 'Address is required.';
					}
					break;
				case 'SummaryPage':
				case 'Payment':
				case 'PaymentConfirmationComponent':
					if (!state.selectedCoverType) {
						errors.selectedCoverType =
							'Please select a cover type.';
					}
					if (state.paymentStatus === 'processing') {
						errors.payment = 'Payment is still processing.';
					}
					if (!state.selectedProduct) {
						errors.selectedProduct =
							'No product selected. Please go back and select a product.';
					}
					if (!state.kycDetails.fullName) {
						errors.fullName = 'Full name is required.';
					}
					if (!state.kycDetails.idNumber) {
						errors.idNumber = 'ID number is required.';
					}
					if (!state.kycDetails.email) {
						errors.email = 'Email address is required.';
					}
					if (!state.kycDetails.phoneNumber) {
						errors.phoneNumber = 'Phone number is required.';
					}
					if (!state.kycDetails.kraPin) {
						errors.kraPin = 'KRA PIN is required.';
					}
					if (!state.kycDetails.address) {
						errors.address = 'Address is required.';
					}
					if (!state.coverDetails.coverPeriod) {
						errors.coverPeriod = 'Cover period is required.';
					}
					if (!state.coverDetails.startDate) {
						errors.startDate = 'Start date is required.';
					}
					break;
			}
			return errors;
		},
		totalPremium: (state) => {
			const basePremium = state.selectedProduct
				? state.selectedProduct.premium || 0
				: 0;
			const optionalBenefitsPremium =
				state.selectedOptionalBenefits.reduce(
					(total, benefit) => total + (benefit.premium || 0),
					0,
				);
			return basePremium + optionalBenefitsPremium;
		},
		selectedOptionalBenefits: (state) =>
			state.selectedOptionalBenefits || [],
		coreBenefitLimits: (state) => state.coreBenefitLimits || {},
		editingCoreBenefits: (state) => state.editingCoreBenefits,
		editingOptionalBenefits: (state) => state.editingOptionalBenefits,
	},
};

export default { namespaced: true, ...motorPrivateModule };
